/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Cooking/Recipe': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M24.25 4h-.75a5 5 0 00-5 5v6a4.99 4.99 0 002.633 4.399c.165.088.367-.042.367-.228v-1.748a.494.494 0 00-.146-.342A2.97 2.97 0 0120.5 15V9c0-1.304.838-2.403 2-2.816V27.75c0 .138.112.25.25.25h1.5a.25.25 0 00.25-.25V4.25a.25.25 0 00-.25-.25m-9 0h-1.5a.25.25 0 00-.25.25V11h-1V4.25a.25.25 0 00-.25-.25h-1.5a.25.25 0 00-.25.25V11h-1V4.25A.25.25 0 009.25 4h-1.5a.25.25 0 00-.25.25V10c0 1.253.384 2.25 1.142 2.965.594.561 1.291.817 1.858.936V27.75c0 .138.112.25.25.25h1.5a.25.25 0 00.25-.25V13.901c.567-.119 1.264-.375 1.858-.936.758-.715 1.142-1.712 1.142-2.965V4.25a.25.25 0 00-.25-.25"/>'
  }
})
